import * as React from 'react';


import styled from '@emotion/styled';
import {Drawer, Typography} from '@mui/material';
import {Box} from '@mui/system';
import {useTranslation} from 'react-i18next';

import {ZmQuaternaryBtn, ZmQuinaryBtn} from 'Components/ZmButtons';


const drawerStyle = ({theme}) => `
.MuiDrawer-paper {
  background: ${theme.palette.background.default};
  border-radius: 16px 16px 0 0;
  box-shadow: 0px 24px 48px rgba(19, 22, 25, 0.1), 0px 12px 24px rgba(19, 22, 25, 0.1);
  height: 80%;
}
`;

const drawerHeaderStyle = ({theme}) => `
  .MuiButtonBase-root.MuiButton-root {
    height: 40px;
    padding: 8px 16px;
    border-radius: 10px;
  }
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 8px 0px 8px;
`;

const StyledDrawer = styled(Drawer)((props) => `
  ${drawerStyle(props)}
`);

const StyledDrawerHeader = styled(Box)((props) => `
  ${drawerHeaderStyle(props)}
`);

/**
 * CustomizedSnackbars Component
 * @param {Object} props
 * @return {ReactElement}
 */
export default function MobileDrawerMenu(props) {
  const {anchor, children, onCancel, onDone, open, title} = props;

  const {t} = useTranslation();

  return (
    <StyledDrawer open={open} anchor={anchor} onClose={onCancel}>
      <StyledDrawerHeader>
        <ZmQuinaryBtn onClick={onCancel}>
          {t('common.cancel')}
        </ZmQuinaryBtn>
        <Typography sx={{fontWeight: 600}}>
          {t(title)}
        </Typography>
        <ZmQuaternaryBtn onClick={onDone}>
          {t('common.done')}
        </ZmQuaternaryBtn>
      </StyledDrawerHeader>
      {children}
    </StyledDrawer>
  );
}
